import { planIntervals } from "@circle-react/helpers/plansHelpers";

import { Fieldset } from "@/react/components/shared/uikit/Fieldset";
import { useBillingCycleState } from "@/react/hooks/useBillingCycleState";

import { useAuxiliaryPlans } from "../../../hooks/useAuxiliaryPlans";
import { AnnualRadioOption } from "./AnnualRadioOption";
import { MonthlyRadioOption } from "./MonthlyRadioOption";

export const BillingIntervalRadio = () => {
  const {
    isYearly,
    shouldShowBillingCycleOptions,
    currentPlan,
    handleIntervalChange,
  } = useBillingCycleState();
  const { areBothIntervalsLoaded, monthlyPlan, yearlyPlan } =
    useAuxiliaryPlans();

  const shouldShowAnnual =
    shouldShowBillingCycleOptions ||
    currentPlan?.interval === planIntervals.year;
  const shouldShowMonthly =
    shouldShowBillingCycleOptions ||
    currentPlan?.interval === planIntervals.month;

  if (!areBothIntervalsLoaded || (!shouldShowAnnual && !shouldShowMonthly)) {
    return null;
  }

  const isOnlyOneOptionVisible = !shouldShowBillingCycleOptions;
  const isAnnualSelected = isOnlyOneOptionVisible || isYearly;
  const isMonthlySelected = isOnlyOneOptionVisible || !isYearly;

  return (
    <Fieldset legend="Billing Cycle">
      {shouldShowAnnual && (
        <AnnualRadioOption
          id="annual-billing"
          interval={planIntervals.year}
          isSelected={isAnnualSelected}
          plan={yearlyPlan}
          onIntervalChange={handleIntervalChange}
        />
      )}
      {shouldShowMonthly && (
        <MonthlyRadioOption
          id="monthly-billing"
          interval={planIntervals.month}
          isSelected={isMonthlySelected}
          plan={monthlyPlan}
          onIntervalChange={handleIntervalChange}
        />
      )}
    </Fieldset>
  );
};

BillingIntervalRadio.displayName = "BillingIntervalRadio";
